import React, { FunctionComponent } from "react";

import "./CartSizeTooltip.scss";
import "../styles.scss";
import { useCart } from "../../../../../context/CartContext";

const CartSizeTooltip: FunctionComponent = () => {
  const { cartModalData } = useCart();

  return <div className="cart-size-tooltip">{cartModalData.length}</div>;
};

export default CartSizeTooltip;
